import React, { Component } from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
Exporting(Highcharts);
ExportingData(Highcharts);


class PromptPercentageDistributionGraph extends Component {

    componentDidMount = () => {
      this.highchartsHandler();
    }

    componentDidUpdate = () => {
        if(this.props.dataAnalytics !== null) {
            this.highchartsHandler();
        }
    }

    highchartsHandler = () => {
        let finalData = [];
        let xAxisLabel = 'Prompt Counts';
        let yAxisLabel = 'Name'; 

        if (this.props.dataAnalytics !== null && this.props.dataAnalytics.data.patientSkillsAcquisitionSingleGraphs.length > 0) {
            this.props.dataAnalytics.data.patientSkillsAcquisitionSingleGraphs.map((obj, index) => {
                        let dataObj = {}
                        dataObj['name'] = obj.name;
                        dataObj['y'] = obj.y;
                        finalData.push(dataObj);
                    })
        }
        Highcharts.setOptions({
            colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4']
        });

        Highcharts.chart('analyticsDataDiv', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            title: {
                text: this.props.graphTitle
            },

            yAxis: {
                title: {
                text: `<b>${xAxisLabel}</b>`
                }
            },

            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                enabled: false
            },

            xAxis: {
                title: {
                    text: `<b>${yAxisLabel}</b>`,
                },
                type: 'category'
            },

            tooltip: {
                enabled: false
            },

            credits: {
                enabled: false
            },

            plotOptions: {
                series: {
                    cursor: 'pointer',
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true
                    },
                    events: {
                        legendItemClick: function () {
                            return false
                        }
                    },
                    marker: {
                        enabled: true        
                    }
                },
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
                
            },

            series: [
                {
                    colorByPoint: true,
                    data: finalData
                }
            ],

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            },

            navigation: {
                buttonOptions: {
                    verticalAlign: 'top',
                    x: -100
                }
            },

            lang: {
                contextButtonTitle: 'Click to open'
            },

            exporting: {
                buttons: {
                    contextButton: {
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                    }
                },
                chartOptions: {
                    //colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
                }
            }
        });
    }


    render() {
        return (
            <div className='row'>
                <div className='col-sm-12'>
                    {
                        this.props.loading ? "Loading..." : <div id='analyticsDataDiv' style={{ height: '500px' }} />
                    }
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {    
    return {
        loading: state.skillAcquisitionTarget.loading,
        dataAnalytics: state.skillAcquisitionTarget.skillAcquisitionTargetSingleGraphData
    };
}

export default connect(mapStateToProps, null)(PromptPercentageDistributionGraph)


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Target/DTTGraphModal/promptPercentageDistributionGraph.js